import Typography from '@mui/material/Typography';
import { BreadCrumbsCnt } from 'pages/Templates/FoldersDetailView/BreadCrumbs/breadCrumbs.style';
import { getSingleFolderCall } from 'api/checklistV2Api';
import { useContext, useEffect, useState } from 'react';
import { MyTemplatesContext } from 'pages/Templates/MyTemplates/myTemplatesContext.tsx/context';
import ArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import TemplateFolderIcon from 'components/Icons/templateFolderIcon';
import { useWorkspaceHook } from 'utils/CustomHooks/useWorkspaceHook';

function BreadCrumbs() {
  const { state = {}, updateState } = useContext(MyTemplatesContext);
  const { selectedFolder } = state;
  const { navigateWithWorkspaceUrl } = useWorkspaceHook();
  const [folder, setFolder] = useState({} as any);

  const getSingleFolder = async () => {
    const folderResponse = await getSingleFolderCall(selectedFolder);
    setFolder(folderResponse?.data);
  };

  const backToChecklistHome = () => {
    updateState({ selectedFolder: null });
    navigateWithWorkspaceUrl('/checklist');
  };
  useEffect(() => {
    getSingleFolder();
  }, []);
  return (
    <BreadCrumbsCnt>
      <Typography
        variant={'h1'}
        className={'heading'}
        onClick={backToChecklistHome}
      >
        Folders
      </Typography>
      <ArrowRightIcon className={'arrowIcon'} />
      <div className={'folderNameCnt'}>
        <TemplateFolderIcon
          primaryColor={folder?.meta?.primaryColor}
          secondaryColor={folder?.meta?.secondaryColor}
        />
        <Typography variant={'h1'} className={'folderName'}>
          {folder?.title}
        </Typography>
      </div>
    </BreadCrumbsCnt>
  );
}

export default BreadCrumbs;
